import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { AsEnumerable } from 'linq-es2015';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import merge from '../../../../../node_modules/deepmerge/dist/es.js';

export interface ITranslationResource {
	prefix: string;
	suffix: string;
}

/*
Code taken from
https://github.com/denniske/ngx-translate-multi-http-loader
License: MIT (https://github.com/denniske/ngx-translate-multi-http-loader/blob/master/LICENSE)
*/
export class MultiTranslateHttpLoader implements TranslateLoader {
	constructor(private _http: HttpClient, private _resources: ITranslationResource[]) {}

	public getTranslation(lang: string): Observable<any> {
		const requests = this._resources.map((resource: ITranslationResource) => {
			return this._http.get(resource.prefix + lang + '/' + lang + resource.suffix);
		});
		return forkJoin(requests).pipe(
			map((response: object[]) => {
				const notEmpty = AsEnumerable(response)
					.Where((x: object) => x != null)
					.ToArray();
				return merge.all(notEmpty);
			})
		);
	}
}
